<template>
  <div class="notFound">
    <img src="/img/notfound/img-empty-saved.svg" alt="">
    <h4 class="small-title title">This folder is empty</h4>
    <p class="description">Start exploring and find our best listing item for your campaign.</p>
  </div>
</template>

<script>
export default {
  name: 'adx-notfound',
  props: {
    title: {
      required: false
    },
    subtitle: {
      required: false
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>